import { mapMutations } from 'vuex'
import validationMixin from '@mixins/validationMixin'
import { GENERAL_STORE } from '../store'

/**
 * Мискин для валидторов формы заказа и добавлениё их в стор. this.addFieldValidator('name', this.$refs.name.$el)
 */
const validationMixinGeneral = {
  data() {
    return {
      validators: [],
    }
  },
  mixins: [validationMixin],

  // Пример валидации полей
  // validations() {
  //   return {
  //     formData: {
  //       alias: {
  //         required: helpers.withMessage(своё сообщение об ошибке, required),
  //       },
  //     },
  //     phone: {
  //       incorrectPhone: helpers.withMessage(
  //         'Укажите корректный номер телефона',
  //         correctPhoneNumber
  //       ),
  //     },
  //   }
  // },
  methods: {
    ...mapMutations(GENERAL_STORE, ['addValidator', 'removeValidator']),

    /**
     * Добавить в стор валидатор
     * @param {string} fieldName путь поля в this.v$, прим. 'dataForm.phone'
     * @param {null | HTMLElement} [elRef] название ссылки на элемент
     */
    addFieldValidator(fieldName, elRef = null) {
      const validator = this.getFieldValidator(fieldName, elRef)

      this.validators.push(validator)
      this.addValidator(validator)
    },
  },

  beforeDestroy() {
    this.validators.forEach(validator => {
      this.removeValidator(validator)
    })
  },

  // Пример добавления валидатора в стор
  // mounted() {
  //   this.addFieldValidator('name', this.$refs.name.$el))
  // },
}

export default validationMixinGeneral
